// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__vfkDq","formBlock":"Contacts_formBlock__ZIYuj","form":"Contacts_form__f8hJt","btn":"Contacts_btn__Dp2m9"};